import { Company, Menu, Permission, SystemSetting, User } from "../../types/auth"
import { PosStation, SalesChannel, Warehouse } from "../../types/models"

const TOKEN_KEY = 'fp_token'
const USER_KEY = 'fp_user'
const COMPANY_KEY = 'fp_company'
const COMPANY_LIST_KEY = 'fp_companyies'
const USER_DATA = 'fp_user_data'

export const tokenManager = {
  get: (): string | null => localStorage.getItem(TOKEN_KEY),
  
  set: (token: string): void => {
    localStorage.setItem(TOKEN_KEY, token)
  },
  
  remove: (): void => {
    localStorage.removeItem(TOKEN_KEY)
  },

  setData: (data: string): void => {
    localStorage.setItem(USER_DATA, JSON.stringify(data))
  },

  getData: (): string | null => {
    const ustring = localStorage.getItem(USER_DATA);
    if (ustring == null || ustring === undefined)
        return null
    const u = JSON.parse(ustring)
    if (u == null)
      return null
    return u
  },
  
  removeData: (): void => {
    localStorage.removeItem(USER_DATA)
  },

  savePassword: (token: string): void => {
    localStorage.setItem('fp_password', token);
  },

  getPassword: (): string | null => {
    return localStorage.getItem('fp_password');
  },
  
  remvoePassword: (): void => {
    localStorage.removeItem('fp_password')
  },

  getUser: (): User | null => {
    const ustring = localStorage.getItem(USER_KEY);
    if (ustring == null || ustring === undefined)
        return null
    const u = JSON.parse(ustring)
    if (u == null)
      return null
    var user: User = u
    user.email = u.email
    user.mobile_number = u.mobile_number
    user.name = u.name
    user.profile_photo = u.profile_photo
    user.uid = u.uid
    return user;
  },
  
  setUser: (user: User): void => {
    localStorage.setItem(USER_KEY, JSON.stringify(user))
  },
  
  removeUser: (): void => {
    localStorage.removeItem(USER_KEY)
  },

  getCompanyList: (): Company[] => {
    const ustring = localStorage.getItem(COMPANY_LIST_KEY);
    if (ustring == null || ustring === undefined)
        return []
    return JSON.parse(ustring)
  },
  
  setCompanyList: (company: Company[]): void => {
    localStorage.setItem(COMPANY_LIST_KEY, JSON.stringify(company))
  },
  
  removeCompanyList: (): void => {
    localStorage.removeItem(COMPANY_LIST_KEY)
  },

  getCompany: (): Company | null => {
    const ustring = localStorage.getItem(COMPANY_KEY);
    if (ustring == null || ustring === undefined)
        return null
    const u = JSON.parse(ustring)
    if (u == null)
      return null
    var company: Company = u
    company.license_expiry = u.license_expiry
    company.company_name = u.company_name
    company.uid = u.uid
    return company;
  },
  
  setCompany: (company: Company): void => {
    localStorage.setItem(COMPANY_KEY, JSON.stringify(company))
  },
  
  removeCompany: (): void => {
    localStorage.removeItem(COMPANY_KEY)
  },

  getMessage: (): string | null => {
    const msg = localStorage.getItem('fp_message');
    localStorage.removeItem('fp_message')
    return msg
  },

  setMessage: (message: string): void => {
    localStorage.setItem('fp_message', message)
  },
  
  removeMessage: (): void => {
    localStorage.removeItem('fp_message')
  },

  getList: (key: string): any => {
    const savedList = localStorage.getItem("fp_" + key);
    if (savedList) {
      return JSON.parse(savedList);
    }
    return []
  },

  saveList: (key: string, data: any): void => {
    localStorage.setItem("fp_" + key, JSON.stringify(data));
  },

  getMenu: (): Menu[] | null => {
    const ustring = localStorage.getItem('fp_menu');
    if (ustring == null || ustring === undefined)
      return null
    const u = JSON.parse(ustring)
    if (u == null)
      return []
    var mnu: Menu[] = u.map((menu: { uid: any; name: any; area: any; group: any; route_path: any; icon_css: any; sort_order: any; modules_id: any; id: any; intro: any }) => ({
      uid: menu.uid,
      name: menu.name,
      area: menu.area,
      group: menu.group,
      route_path: menu.route_path,
      icon_css: menu.icon_css,
      sort_order: menu.sort_order,
      modules_id: menu.modules_id,
      id: menu.id,
      intro: menu.intro
    }))
    return mnu
  },
  
  setMenu: (menu: Menu[]): void => {
    localStorage.setItem('fp_menu', JSON.stringify(menu))
  },
  
  removeMenu: (): void => {
    localStorage.removeItem('fp_menu')
  },

  getPermissions: (): Permission[] | [] => {
    const us = localStorage.getItem('fp_permission')
    if (us == null)
      return []
    const u = JSON.parse(us)
    if (u == null)
      return []
    var perm: Permission[] = u.map((permission: { uid: any; name: any; area: any; group: any; route_path: any; icon_css: any; sort_order: any; modules_id: any; permission: any }) => ({
      uid: permission.uid,
      name: permission.name,
      area: permission.area,
      group: permission.group,
      route_path: permission.route_path,
      icon_css: permission.icon_css,
      sort_order: permission.sort_order,
      modules_id: permission.modules_id,
      permission: permission.permission
    }))
    return perm
  },
  
  setPermissions: (company: Company): void => {
    localStorage.setItem('fp_permission', JSON.stringify(company))
  },
  
  removePermissions: (): void => {
    localStorage.removeItem('fp_permission')
  },

  getSettings: (): SystemSetting[] | [] => {
    const us = localStorage.getItem('fp_settings')
    if (us == null)
      return []
    const u = JSON.parse(us)
    if (u == null)
      return []
    var set: SystemSetting[] = u.map((setting: { uid: any; name: any; caption: any; value: any; }) => ({
      uid: setting.uid,
      name: setting.name,
      caption: setting.caption,
      value: setting.value,
    }))
    return set
  },
  
  getSetting: (key: string, number: boolean = false): string | number=> {
    let set = tokenManager.getSettings().find((e) => e.name == key)
    if (set?.value && number) {
      return parseInt(set?.value)
    }
    return set?.value || ''
  },

  setSettings: (settings: SystemSetting): void => {
    localStorage.setItem('fp_settings', JSON.stringify(settings))
  },
  
  removeSettings: (): void => {
    localStorage.removeItem('fp_settings')
  },

  getTheme: (): string => {
    let set = localStorage.getItem('fp_theme')
    return set || ''
  },

  setTheme: (theme: string): void => {
    localStorage.setItem('fp_theme', theme)
  },

  getSyncTime: (): string => {
    let set = localStorage.getItem('fp_sync_time')
    return set || ''
  },

  setSyncTime: (theme: string): void => {
    localStorage.setItem('fp_sync_time', theme)
  },

  getPosStation: (): PosStation | null => {
    let us = localStorage.getItem('fp_pos_station')
    if (us == null)
      return null
    const u = JSON.parse(us)
    if (u == null)
      return null
    return u;
  },

  setPosStation: (station: PosStation): void => {
    localStorage.setItem('fp_pos_station', JSON.stringify(station))
  },

  getSideBarStatus: (): boolean => {
    let set = localStorage.getItem('fp_side_bar')
    return set === 'true' || false
  },

  setSideBarStatus: (minimized: boolean): void => {
    localStorage.setItem('fp_side_bar', minimized.toString())
  },

  getPriceList: (): any | null=> {
    let us = localStorage.getItem('fp_mobile_sales_price_list')
    if (us == null)
      return null
    const u = JSON.parse(us)
    if (u == null)
      return null
    return u;
  },

  setPriceList: (price_list: any): void => {
    localStorage.setItem('fp_mobile_sales_price_list', JSON.stringify(price_list))
  },

  getWarehouse: (): Warehouse | null => {
    let us = localStorage.getItem('fp_mobile_sales_warehouse')
    if (us == null)
      return null
    const u = JSON.parse(us)
    if (u == null)
      return null
    return u;
  },

  setWarehouse: (warehouse: Warehouse): void => {
    localStorage.setItem('fp_mobile_sales_warehouse', JSON.stringify(warehouse))
  },

  getSalesChannel: (): SalesChannel | null => {
    let us = localStorage.getItem('fp_mobile_sales_channel')
    if (us == null)
      return null
    const u = JSON.parse(us)
    if (u == null)
      return null
    return u;
  },

  setSalesChannel: (channel: SalesChannel): void => {
    localStorage.setItem('fp_mobile_sales_channel', JSON.stringify(channel))
  },


  logout: (): void => {
    tokenManager.remove()
    tokenManager.removeUser()
    tokenManager.removeCompanyList()
    tokenManager.removeCompany()
  },
  
  getAuthHeader: (): Record<string, string> | undefined => {
    const token = tokenManager.get()
    //const company = tokenManager.getCompany() != null ? tokenManager.getCompany().uid : ''
    return token ? { Authorization: `Bearer ${token}` } : undefined
  }
}